import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=752b31fa&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=752b31fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b31fa",
  null
  
)

export default component.exports